var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"vf-spinning-loader vf-icon",class:("vf-icon-" + (_vm.props.size) + " " + (_vm.data.staticClass) + " vf-spinning-loader--" + (_vm.props.palette))},'div',_vm.data.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }